


















import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
  middleware: ['authGuard', 'hubspot', 'hotjar', 'accountSetupGuard'],
  computed: {
    ...mapState('user', ['overrideMobileWarning'])
  }
});
